/**
 * Build-time configuration for the API surface.
 */

/**
 * Base URL for the Ito API, from `VITE_API_BASE_URL`. Defaults to "" so
 * requests stay relative (the Vite dev proxy handles them); packaged
 * Capacitor/Tauri builds set it to the API origin.
 */
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? "";
